import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { MapPage } from "./pages/MapPage";
import { ShiftsPage } from "./pages/ShiftsPage";
import { PatrolPage } from "./pages/PatrolPage";
import { IncidentsPage } from "./pages/IncidentsPage";
import { ObservationsPage } from "./pages/ObservationsPage";
import { DevicesPage } from "./pages/DevicesPage";
import { UsersPage } from "./pages/UsersPage";
import { GeoPage } from "./pages/GeoPage";
import { TagsPage } from "./pages/TagsPage";
import { ReferencePage } from "./pages/ReferencePage";
import { AuditPage } from "./pages/AuditPage";
import { ReportsPage } from "./pages/ReportsPage";
import { EquipmentPage } from "./pages/EquipmentPage";
import { TokensPage } from "./pages/TokensPage";
import { AssignmentsPage } from "./pages/AssignmentsPage";
import { StatusPage } from "./pages/StatusPage";

export function App() {
  const { me, loading } = useAuth();

  if (loading) return <div className="notice" style={{ padding: 32 }}>Загрузка…</div>;
  if (!me) return <LoginPage />;

  // Научный сотрудник работает только с реестром наблюдений: служебные
  // треки и лента происшествий ему не положены. Сервер это тоже проверяет —
  // здесь лишь не показываем то, что всё равно будет отвергнуто.
  const home = me.can_read_patrol_data ? "/incidents" : "/observations";

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={home} replace />} />
        <Route path="/observations" element={<ObservationsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        {me.can_read_patrol_data && (
          <>
            <Route path="/map" element={<MapPage />} />
            <Route path="/shifts" element={<ShiftsPage />} />
            <Route path="/patrols/:id" element={<PatrolPage />} />
            <Route path="/incidents" element={<IncidentsPage />} />
            <Route path="/devices" element={<DevicesPage />} />
          </>
        )}
        {me.can_manage_users && <Route path="/assignments" element={<AssignmentsPage />} />}
        {me.can_manage_users && <Route path="/users" element={<UsersPage />} />}
        {me.can_manage_users && <Route path="/geo" element={<GeoPage />} />}
        {me.can_manage_users && <Route path="/tags" element={<TagsPage />} />}
        {me.can_manage_users && <Route path="/equipment" element={<EquipmentPage />} />}
        {me.can_manage_users && <Route path="/tokens" element={<TokensPage />} />}
        {me.can_manage_species && <Route path="/reference" element={<ReferencePage />} />}
        {me.can_read_audit && <Route path="/audit" element={<AuditPage />} />}
        {me.can_read_audit && <Route path="/status" element={<StatusPage />} />}
        <Route path="*" element={<Navigate to={home} replace />} />
      </Routes>
    </Layout>
  );
}
